import { jsx as e, jsxs as U } from "react/jsx-runtime";
import { useState as K, useCallback as Z, useMemo as P, useContext as M, useRef as ee, Fragment as te } from "react";
import { identity as oe } from "../util/index.js";
import { ChartCoreContext as X } from "./ChartCoreContext.js";
import { ChartLegend as ie } from "./Legend.js";
import { LineChartContext as z } from "./LineChartContext.js";
import { ChartTooltip as re } from "./Tooltip.js";
import { TooltipContext as ae } from "./TooltipContext.js";
import { constructCategoryColors as se, getColorClassName as R, hasOnlyOneValueForKey as ne, AvailableChartColors as le, getYAxisDomain as ce } from "./chartUtils.js";
import { ResponsiveContainer as de, LineChart as me, CartesianGrid as ue, XAxis as pe, Label as _, YAxis as fe, Line as he, Tooltip as xe, Dot as ye } from "recharts";
import { twMerge as G } from "tailwind-merge";
const $ = 15, q = 3, Ce = (u) => {
  const {
    data: n = [],
    categories: l = [],
    index: c,
    colors: i = le,
    enableLegendToggle: r = !1,
    valueFormatter: a = (d) => d.toString(),
    tickFormatter: o = oe,
    startEndOnly: y = !1,
    showXAxis: L = !0,
    showYAxis: k = !0,
    showGridLines: C = !0,
    yAxisWidth: g = 56,
    intervalType: p = "equidistantPreserveStart",
    autoMinValue: A = !1,
    minValue: T,
    maxValue: b,
    allowDecimals: v = !0,
    connectNulls: f = !1,
    onValueChange: s,
    tickGap: h = 5,
    xAxisLabel: N,
    yAxisLabel: w,
    children: W
  } = u, [x, F] = K(void 0), [D, Y] = K(!0), S = se(l, i), O = Z(
    (d) => {
      r && (F(d === x ? void 0 : d), s == null || s({
        eventType: "category",
        categoryClicked: d
      }));
    },
    [x, r, s]
  ), V = P(
    () => ({
      colors: i,
      startEndOnly: y,
      showXAxis: L,
      showYAxis: k,
      showGridLines: C,
      yAxisWidth: g,
      intervalType: p,
      autoMinValue: A,
      minValue: T,
      maxValue: b,
      allowDecimals: v,
      connectNulls: f,
      tickGap: h,
      xAxisLabel: N,
      yAxisLabel: w,
      onValueChange: s,
      tickFormatter: o
    }),
    [
      v,
      A,
      i,
      f,
      p,
      b,
      T,
      s,
      C,
      L,
      k,
      y,
      o,
      h,
      N,
      w,
      g
    ]
  ), t = P(
    () => ({
      index: c,
      data: n,
      activeLegend: x,
      categories: l,
      valueFormatter: a,
      categoryColors: S,
      isTooltipActive: D,
      enableLegendToggle: r,
      setIsTooltipActive: Y,
      setActiveLegend: F,
      selectCategory: O
    }),
    [
      c,
      n,
      l,
      x,
      r,
      a,
      S,
      D,
      O
    ]
  );
  return /* @__PURE__ */ e(X.Provider, { value: t, children: /* @__PURE__ */ e(z.Provider, { value: V, children: W }) });
}, ge = (u) => {
  const { className: n, children: l, ...c } = u, {
    index: i,
    categories: r,
    data: a,
    activeLegend: o,
    categoryColors: y,
    enableLegendToggle: L,
    valueFormatter: k,
    selectCategory: C,
    setIsTooltipActive: g
  } = M(X), {
    startEndOnly: p,
    intervalType: A,
    tickGap: T,
    showGridLines: b,
    showXAxis: v,
    showYAxis: f,
    xAxisLabel: s,
    yAxisLabel: h,
    yAxisWidth: N,
    autoMinValue: w,
    minValue: W,
    maxValue: x,
    allowDecimals: F,
    connectNulls: D,
    tickFormatter: Y
  } = M(z), S = ee(null), O = ce(!!w, W, x), V = !v && !f || p && !f ? 0 : 20;
  return /* @__PURE__ */ e(
    "div",
    {
      className: G("h-80 w-full", n),
      onMouseEnter: () => {
        g(!0);
      },
      onMouseLeave: (t) => {
        t.target !== S.current && g(!1);
      },
      ...c,
      children: /* @__PURE__ */ e(de, { className: n, children: /* @__PURE__ */ U(
        me,
        {
          data: a,
          margin: {
            left: h ? q : 0,
            bottom: s ? $ : 0
          },
          children: [
            b && /* @__PURE__ */ e(
              ue,
              {
                className: "stroke-gray-200 stroke-1",
                horizontal: !0,
                vertical: !1
              }
            ),
            /* @__PURE__ */ e(
              pe,
              {
                padding: { left: V, right: V },
                hide: !v,
                dataKey: i,
                interval: p ? "preserveStartEnd" : A,
                tick: { transform: "translate(0, 6)" },
                ticks: p ? [a[0][i], a[a.length - 1][i]] : void 0,
                className: "fill-gray-500 text-xs",
                tickLine: !1,
                axisLine: !1,
                minTickGap: T,
                children: s && /* @__PURE__ */ e(
                  _,
                  {
                    position: "insideBottom",
                    offset: -$,
                    className: "fill-gray-800 text-sm font-medium",
                    children: s
                  }
                )
              }
            ),
            /* @__PURE__ */ e(
              fe,
              {
                width: N,
                hide: !f,
                axisLine: !1,
                tickLine: !1,
                type: "number",
                domain: O,
                tick: { transform: "translate(-3, 0)" },
                className: G("fill-gray-500 text-xs"),
                tickFormatter: (t) => Y(k(t), t),
                allowDecimals: F,
                children: h && /* @__PURE__ */ e(
                  _,
                  {
                    position: "insideLeft",
                    style: { textAnchor: "middle" },
                    angle: -90,
                    offset: q,
                    className: "fill-gray-800 text-sm font-medium",
                    children: h
                  }
                )
              }
            ),
            r.map((t) => {
              const d = (m) => {
                const {
                  cx: E,
                  cy: j,
                  stroke: B,
                  strokeLinecap: H,
                  strokeLinejoin: J,
                  strokeWidth: Q,
                  dataKey: I
                } = m;
                return /* @__PURE__ */ e(
                  ye,
                  {
                    role: "button",
                    "aria-label": `Dot ${t}`,
                    className: G(
                      "stroke-white",
                      L ? "cursor-pointer" : "",
                      R(
                        y.get(I),
                        "fill"
                      )
                    ),
                    cx: E,
                    cy: j,
                    r: 5,
                    stroke: B,
                    strokeLinecap: H,
                    strokeLinejoin: J,
                    strokeWidth: Q,
                    onClick: () => {
                      C(I);
                    }
                  }
                );
              };
              return /* @__PURE__ */ e(
                he,
                {
                  name: t,
                  type: "linear",
                  dataKey: t,
                  stroke: "",
                  strokeWidth: 2,
                  strokeLinejoin: "round",
                  strokeLinecap: "round",
                  isAnimationActive: !1,
                  connectNulls: D,
                  strokeOpacity: o && o !== t ? 0.3 : 1,
                  className: G(
                    R(
                      y.get(t),
                      "stroke"
                    )
                  ),
                  onClick: (m) => {
                    const { name: E } = m;
                    C(E);
                  },
                  activeDot: (m) => /* @__PURE__ */ e(d, { ...m }),
                  dot: (m) => {
                    const { key: E, ...j } = m;
                    return /* @__PURE__ */ e(te, { children: ne(a, t) && !(o && o !== t) && /* @__PURE__ */ e(d, { ...j }) }, m.key);
                  }
                },
                t
              );
            }),
            l
          ]
        }
      ) })
    }
  );
}, ve = (u) => {
  const { className: n, ...l } = u, { categories: c = [] } = M(X), i = c.map((r) => ({
    type: void 0,
    value: r
  }));
  return /* @__PURE__ */ e(ie, { className: n, payload: i, ...l });
}, Le = (u) => {
  const { children: n, ...l } = u, { index: c, categoryColors: i } = M(X);
  return /* @__PURE__ */ e(
    xe,
    {
      isAnimationActive: !0,
      animationDuration: 100,
      cursor: { stroke: "#d1d5db", strokeWidth: 1 },
      offset: 20,
      position: { y: 0 },
      content: (r) => {
        const a = r.payload.map((o) => ({
          category: o.dataKey,
          value: o.value,
          index: o.payload[c],
          color: i.get(o.dataKey),
          type: o.type,
          payload: o.payload
        }));
        return /* @__PURE__ */ e(ae.Provider, { value: r, children: n || /* @__PURE__ */ e(re, { payload: a }) });
      },
      ...l
    }
  );
}, Ee = Ce, Ge = ge, Me = ve, Xe = Le;
export {
  Ge as Content,
  Me as Legend,
  Ce as LineChart,
  ge as LineChartContent,
  ve as LineChartLegend,
  Le as LineChartTooltip,
  Ee as Root,
  Xe as Tooltip
};
